import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('yeti', {
  cherry: 'fur_tuft',
  lemon: 'big_footprint',
  orange: 'icefish',
  bell: 'cave_bell',
  star: 'yeti_wild',
  seven: 'cave_entrance',
  gem: 'frost_gem',
  scatter: 'paw_scatter',
  money: 'fur_hoard',
});

/** Yeti's Den — GENERATED by scaffoldSlot from
 *  content/slots/yeti.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const YETI_THEME: Theme = {
  id: 'yeti',
  name: 'Yeti\'s Den',
  palette: {
    accent: 0x88b0c8,
    secondary: 0xc4dae8,
    warm: 0xf2d27a,
    frameFill: 0x1c2630,
    bgGradientTop: 0x33454f,
    bgGradientBottom: 0x10171c,
    dimOverlay: 0x080c0f,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Fur Tuft', glyph: '🟫', tint: 0xb89b76, weight: 5, textureAlias: 'yeti:cherry',
        winVideoAlias: 'yeti:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Footprint', glyph: '👣', tint: 0x6f8aa0, weight: 5, textureAlias: 'yeti:lemon',
        winVideoAlias: 'yeti:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Ice Fish', glyph: '🐟', tint: 0x8fb8c8, weight: 4, textureAlias: 'yeti:orange',
        winVideoAlias: 'yeti:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Cave Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'yeti:bell',
        winVideoAlias: 'yeti:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Yeti', glyph: '👣', tint: 0xeaf0f5, weight: 2, textureAlias: 'yeti:star',
        winVideoAlias: 'yeti:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Yeti\'s Den', glyph: '🕳️', tint: 0x5f7d92, weight: 2, textureAlias: 'yeti:seven',
        winVideoAlias: 'yeti:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Frost Gem', glyph: '💎', tint: 0x88b0c8, weight: 2.5, textureAlias: 'yeti:gem',
        winVideoAlias: 'yeti:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Paw Print', glyph: '🐾', tint: 0xc4dae8, weight: 0.5, textureAlias: 'yeti:scatter',
        winVideoAlias: 'yeti:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Den Hoard', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'yeti:money',
        winVideoAlias: 'yeti:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x1c2630, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x88b0c8, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xc4dae8, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x88b0c8, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x1c2630, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xc4dae8, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x88b0c8, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf2d27a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'yeti:bg', path: 'environment/yeti.png' },
      columnBackground: { alias: 'yeti:column_bg', path: 'reel/yeti_column_bg.png' },
      border: { alias: 'yeti:border', path: 'brand/border_frost.png' },
    },
  },
};
